import React from "react";

type Props = {
  className?: string;
};
export const MicCrossedIcon: React.FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1487_15858)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.61189 -0.000488281C6.52571 -0.000488281 4.83356 1.69165 4.83356 3.77784V9.44489C4.83356 9.99247 4.95014 10.5129 5.15983 10.9827L12.3901 3.7524C12.3764 1.67793 10.6896 -0.000488281 8.61189 -0.000488281ZM12.3902 8.65895L7.8941 13.1551C8.1265 13.1998 8.36647 13.2232 8.61189 13.2232C10.6981 13.2232 12.3902 11.5311 12.3902 9.44489V8.65895ZM4.45458 11.688C4.30213 11.4061 4.17751 11.107 4.08442 10.7943C3.9578 10.3684 3.88962 9.91499 3.88962 9.44481C3.88962 8.92326 3.46636 8.5 2.94481 8.5C2.42326 8.5 2 8.92326 2 9.44481C2 10.1001 2.09562 10.7341 2.27449 11.3335C2.45885 11.9533 2.7317 12.535 3.07842 13.0641L4.45458 11.688ZM5.67794 15.3712L7.122 13.9272C7.59051 14.0828 8.09149 14.1671 8.61194 14.1671C10.7495 14.1671 12.5585 12.7459 13.1395 10.7943C13.2661 10.3684 13.3343 9.91499 13.3343 9.44481C13.3343 8.92326 13.7575 8.5 14.2791 8.5C14.8006 8.5 15.2239 8.92326 15.2239 9.44481C15.2239 10.1001 15.1282 10.7341 14.9494 11.3335H14.9492C14.224 13.7713 12.1297 15.621 9.55664 15.9893V17.9454C9.55664 18.4669 9.13338 18.8902 8.61183 18.8902C8.09028 18.8902 7.66702 18.4669 7.66702 17.9454V15.9893C6.96191 15.8884 6.29278 15.6762 5.67794 15.3712Z"
        />
        <line
          x1="1.29289"
          y1="17.2929"
          x2="16.2929"
          y2="2.29289"
          strokeWidth="2"
        />
      </g>
      <defs>
        <clipPath id="clip0_1487_15858">
          <rect width="18" height="19" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
